import React, {useEffect, useState} from "react";
import MaterialUiInput from "../../../common/inputs/MaterialUiInput";
import SimpleTable from "../../../common/tables/SimpleTable";
import {useDispatch, useSelector} from "react-redux";
import {
    loadPartnerDomains,
    parkPartnerDomain,
    deletePartnerDomain,
    makePartnerDomainDefault
} from "../../../../actions/partnerDomainsActions";
import Spinner from "../../../common/Spinner";
import NoContentMessage from "../../../common/NoContentMessage";
import ActionPopover from "../../../common/popovers/ActionPopover";


export default function PartnerDomainsContent({}) {
    const dispatch = useDispatch();
    const domains = useSelector(state => state.partnerDomainsReducer.partnerDomains);
    const isLoading = useSelector(state => state.partnerDomainsReducer.isLoading);
    const error = useSelector(state => state.error.data);

    const [cname, setCname] = useState("");

    useEffect(() => {
        dispatch(loadPartnerDomains(false));
    }, []);

   const handleTextTyping = (value) => {
       setCname(value)
    };

    const parkDomain = () => {
        cname && cname !== "" && dispatch(parkPartnerDomain(cname, () => createDomainSuccessCallback()));
    };

    const createDomainSuccessCallback = () => {
        setCname("");
        dispatch(loadPartnerDomains());
    };

    const deleteDomain = (domain) => {
        domain && dispatch(deletePartnerDomain(domain, () => dispatch(loadPartnerDomains())));

    };

    const makeDefault = (domain) => {
        const result = {id: domain.id, defaultDomain: !domain.defaultDomain}
        dispatch(makePartnerDomainDefault(result, () => dispatch(loadPartnerDomains())));
    };


    const tableColumns = () => {
        return [
            {
                name: "",
                key: "defaultDomainAction",
                getBodyCellValue: domain => <i className={domain.defaultDomain ? "fa fa-star" : "fa fa-star-o"}
                                               title="Добавить в избранные"
                                               style={{cursor: "pointer"}}
                                               onClick={() => makeDefault(domain)}/>,
                headerCellStyle: {minWidth: "30px", width: "30px"}
            },
            {
                name: "Припаркованные домены",
                key: "domain",
                getBodyCellValue: domain => domain.id + " | " + domain.cname,
            },
            {
                name: "Дата",
                key: "createDate",
                getBodyCellValue: domain => domain.createDate ? domain.createDate : "",
            },
            {
                name: "",
                key: "deleteDomainAction",
                getBodyCellValue: domain => <>
                        <ActionPopover
                            button={<i
                                className="ti ti-trash td-save"
                                title="Удалить домен"/>}
                            popoverLocation='left'
                            label='Удалить домен?'
                            handleSubmit={() => deleteDomain(domain)}/>
                    </>,
                headerCellStyle: {minWidth: "30px", width: "30px"}
            },
        ]
    };


        return (
            <div className="tab-pane fade active show padding5" id="custom-nav-domains" role="tabpanel"
                 aria-labelledby="custom-nav-domains-tab">
                <p><b>Информация для парковки домена:</b></p>
                <ul className="ul-num">
                    <li>1. Создайте запись CNAME в разделе редактирования DNS-зоны вашего домена со значением
                        parking.affimob.com
                    </li>
                    <li>2. Дождитесь обновления dns-записей</li>
                    <li>3. Добавьте домен в нашу систему используя форму ниже</li>
                    <li>4. Припаркованный домен может использоваться для направления трафика и будет отображаться в
                        списке
                        доменов
                    </li>
                    <li>5. При необходимости отметьте звёздочкой <i className="fa fa-star"/> домен, который будет
                        подставляться в ваши ссылки по умолчанию
                    </li>
                </ul>
                <div className="domain-input">
                    <div className="jss8">
                        <MaterialUiInput onTextTyping={handleTextTyping} value={cname}/>
                    </div>
                    <div>
                        <button className="circle-btn btn-plus" title="Добавить домен" onClick={parkDomain}>
                            <i className="ti ti-plus"/>
                        </button>
                    </div>
                </div>
                <div>
                    <div className="responsive-block" id="fullWidth">
                        {isLoading
                            ? <Spinner/>
                            : (!domains || domains.length === 0)
                                ? <div style={{justifyContent: "center"}} className='row col-12'><NoContentMessage
                                    message="У вас нет припаркованных доменов"/></div>
                                : <SimpleTable columns={tableColumns()} data={domains} bodyRowKey="id"/>
                        }
                    </div>
                </div>


            </div>
        );
}